
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Mission() {
  const left = useScrollAnimation();
  const right = useScrollAnimation();

  return (
    <section className="py-28 px-8 bg-white">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <div
            ref={left.ref}
            className={`transition-all duration-1000 ${
              left.isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
            }`}
          >
            <span className="text-xs font-semibold text-[#0066CC] uppercase tracking-[0.2em] mb-4 block">Our Mission</span>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2332] mb-8 leading-tight">
              Technology that <em className="not-italic text-[#0066CC]">empowers</em> every business to thrive
            </h2>
            <p className="text-base text-gray-600 leading-relaxed mb-6">
              We founded TechVision with a singular belief: every organization deserves access to world-class technology solutions. Our mission is to bridge the gap between complex enterprise technology and real business outcomes.
            </p>
            <p className="text-base text-gray-600 leading-relaxed mb-10">
              From startups scaling their first product to Fortune 500 companies modernizing legacy systems, we partner with leaders who refuse to settle for the status quo. Our approach combines deep technical expertise with genuine business understanding.
            </p>
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-[#0066CC]/10 flex items-center justify-center">
                  <i className="ri-check-line text-lg text-[#0066CC]"></i>
                </div>
                <span className="text-sm font-medium text-[#1A2332]">ISO 27001 Certified</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-[#0066CC]/10 flex items-center justify-center">
                  <i className="ri-check-line text-lg text-[#0066CC]"></i>
                </div>
                <span className="text-sm font-medium text-[#1A2332]">AWS Partner</span>
              </div>
            </div>
          </div>

          <div
            ref={right.ref}
            className={`relative transition-all duration-1000 delay-200 ${
              right.isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'
            }`}
          >
            <div className="relative">
              <div className="w-full h-[520px] rounded-3xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/99d0818fd2285cb5a995b85a9ece8f75.jpg"
                  alt="Team collaboration"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-[#1A2332] text-white rounded-2xl p-6 shadow-xl">
                <div className="text-3xl font-bold mb-1">15+</div>
                <div className="text-sm text-gray-300">Years of delivering<br />enterprise solutions</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
